require('uploadcare-widget');
require('./wcu');
